<app-loading-panel
  [showLoading]="!isLoaded"
  [hideText]="true"
  [isSmall]="true"
></app-loading-panel>

<ng-container *ngIf="isLoaded">
  <!-- Desktop table -->
  <div
    class="d-none d-md-block"
    [class.admin-voucher-layout]="isAdminVoucherLayout"
  >
    <table class="table">
      <thead>
        <tr>
          <th *ngIf="!showGiftCardColumns" class="voucher-code-column">
            {{ 'admin.global.voucher.label' | translate }}
          </th>
          <th *ngIf="!showGiftCardColumns" class="voucher-type-column">
            {{ 'admin.global.type' | translate }}
          </th>
          <th class="voucher-value-column">
            {{ 'admin.global.value' | translate }}
          </th>
          <th *ngIf="!showGiftCardColumns" class="voucher-initial-value-column">
            {{ 'admin.global.initialValue' | translate }}
          </th>
          <th class="voucher-min-order-column">
            {{ 'admin.global.minorderamount' | translate }}
          </th>
          <th *ngIf="!showGiftCardColumns" class="voucher-active-column">
            {{ 'admin.global.active' | translate }}
          </th>
          <th *ngIf="!showGiftCardColumns" class="voucher-consumed-column">
            {{ 'admin.global.consumed' | translate }}
          </th>
          <th class="voucher-availability-column">
            {{ 'admin.global.availabilityRestrictions' | translate }}
          </th>
          <th *ngIf="hasTopupActions" class="voucher-actions-header"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!vouchers.length">
          <td [attr.colspan]="noDataColspan">
            {{ 'admin.global.noData' | translate }}
          </td>
        </tr>
        <tr
          *ngFor="let row of vouchers"
          [class.inactive-row]="row.inactive"
          [class.clickable-row]="clickableRows"
          (click)="onRowClick(row)"
        >
          <td *ngIf="!showGiftCardColumns" class="voucher-code-column">
            {{ row.code }}
            <i
              class="far fa-copy ml-2 cursor-pointer copy-icon"
              (click)="onCopyClick($event, row.code)"
            ></i>
          </td>
          <td *ngIf="!showGiftCardColumns" class="voucher-type-column">
            {{ row.typeText }}
            <i
              *ngIf="row.source === 'GIFT_CARD'"
              class="fa-solid fa-gift mr-2 ml-2 primary-brand-color"
            ></i>
          </td>
          <td class="voucher-value-column">{{ row.displayValue }}</td>
          <td *ngIf="!showGiftCardColumns" class="voucher-initial-value-column">
            {{ row.initialValue }}
          </td>
          <td class="voucher-min-order-column">{{ row.orderMinAmount }}</td>
          <td *ngIf="!showGiftCardColumns" class="voucher-active-column">
            {{ row.activeText }}
          </td>
          <td *ngIf="!showGiftCardColumns" class="voucher-consumed-column">
            {{ row.consumedText }}
          </td>
          <td class="voucher-availability-column">
            {{ row.availabilityText }}
          </td>
          <td *ngIf="hasTopupActions" class="voucher-actions-cell text-right">
            <app-button
              *ngIf="row.showTopupAction"
              variant="primary"
              classes="voucher-topup-button"
              type="button"
              startIcon="fa-credit-card mr-1"
              (click)="onTopupClick($event, row)"
            >
              {{ 'admin.store.voucher.topUp' | translate }}
            </app-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile cards -->
  <div
    class="d-block d-md-none"
    [class.admin-voucher-layout]="isAdminVoucherLayout"
  >
    <div class="mobile-no-data" *ngIf="!vouchers.length">
      {{ 'admin.global.noData' | translate }}
    </div>
    <div
      class="voucher-mobile-card"
      *ngFor="let row of vouchers"
      [class.inactive-row]="row.inactive"
      [class.clickable-row]="clickableRows"
      (click)="onRowClick(row)"
    >
      <div
        class="mobile-row mobile-voucher-code-row"
        *ngIf="!showGiftCardColumns"
      >
        <span class="mobile-label">{{
          'admin.global.voucher.label' | translate
        }}</span>
        <span class="mobile-value">
          {{ row.code }}
          <i
            class="far fa-copy ml-2 cursor-pointer copy-icon"
            (click)="onCopyClick($event, row.code)"
          ></i>
        </span>
      </div>
      <div class="mobile-row mobile-type-row" *ngIf="!showGiftCardColumns">
        <span class="mobile-label">{{ 'admin.global.type' | translate }}</span>
        <span class="mobile-value">
          {{ row.typeText }}
          <i
            *ngIf="row.source === 'GIFT_CARD'"
            class="fa-solid fa-gift ml-2 primary-brand-color"
          ></i>
        </span>
      </div>
      <div class="mobile-row mobile-value-row">
        <span class="mobile-label">{{ 'admin.global.value' | translate }}</span>
        <span class="mobile-value">{{ row.displayValue }}</span>
      </div>
      <div
        class="mobile-row mobile-initial-value-row"
        *ngIf="!showGiftCardColumns && row.initialValue"
      >
        <span class="mobile-label">{{
          'admin.global.initialValue' | translate
        }}</span>
        <span class="mobile-value">{{ row.initialValue }}</span>
      </div>
      <div class="mobile-row mobile-min-order-row" *ngIf="row.orderMinAmount">
        <span class="mobile-label">{{
          'admin.global.minorderamount' | translate
        }}</span>
        <span class="mobile-value">{{ row.orderMinAmount }}</span>
      </div>
      <div class="mobile-row mobile-active-row" *ngIf="!showGiftCardColumns">
        <span class="mobile-label">{{
          'admin.global.active' | translate
        }}</span>
        <span class="mobile-value">{{ row.activeText }}</span>
      </div>
      <div class="mobile-row mobile-consumed-row" *ngIf="!showGiftCardColumns">
        <span class="mobile-label">{{
          'admin.global.consumed' | translate
        }}</span>
        <span class="mobile-value">{{ row.consumedText }}</span>
      </div>
      <div class="mobile-row mobile-availability-row">
        <span class="mobile-label">{{
          'admin.global.availabilityRestrictions' | translate
        }}</span>
        <span class="mobile-value">{{ row.availabilityText }}</span>
      </div>
      <div class="mobile-action-row" *ngIf="row.showTopupAction">
        <app-button
          variant="primary"
          classes="voucher-mobile-topup-button"
          type="button"
          startIcon="fa-credit-card mr-1"
          (click)="onTopupClick($event, row)"
        >
          {{ 'admin.store.voucher.topUp' | translate }}
        </app-button>
      </div>
    </div>
  </div>
</ng-container>

<app-pager
  [totalPagesCount]="totalPages"
  [page]="pageNumber"
  [size]="pageSize"
  (paginate)="paginate.emit($event)"
></app-pager>
